/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-undef */
import React, { PureComponent } from 'react';
import axios from 'axios';
import Multicolumntile from './components/Multicolumntile/Multicolumntile';
import Imagetext from './components/Imagetext/Imagetext';
import Salesinformation from './components/Salesinformation/Salesinformation';
import VideoComponent from './components/Video/Video';
import Notification from './components/Notification/Notification';
import Richtext from './components/Richtext/Richtext';
import Placement from './components/Placement/Placement';

// TODO: use passed in urlSearchParams & currentPage to fetch data as seen in ClientLoader
class AuthorLoader extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { data: [] };

    this.getComponentJsonPath = () => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search.slice(1));
      return params.get('path') || '';
    };
    this.getComponentResource = () => {
      const url = new URL(window.location.href);
      const resource = new URLSearchParams(url.search.slice(1)).get('resource').split('/').slice(-1)[0];
      return resource;
    };
    this.getComponentName = () => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('name');
    };
    this.renderComponents = (componentName) => {
      const { data } = this.state;
      const components = {
        Salesinformation,
        Imagetext,
        Multicolumntile,
        Video: VideoComponent,
        Notification,
        Richtext,
        Placement
      };
      const Component = components[componentName];
      return Object.keys(data).length
        ? <Component {...data} />
        : null;
    };
    this.fetchData = async () => {
      await this.fetchComponentData();
    };
    this.fetchComponentData = async () => {
      const response = await axios.get(this.getComponentJsonPath(), { withCredentials: true });
      return this.massageComponentData(response, this.getComponentResource());
    };
    this.massageComponentData = (response, resource) => {
      const data = response.data['jcr:content'];
      // Checking for multicomponent page then assigning resource component to root
      if (data.root[resource]) {
        data.isFirstOnMultiComponentPage = (Object.keys(data.root).filter(item =>
          item.startsWith(resource.split('_')[0]))[0] === resource);
        data.root[resource]['jcr:title'] = data['jcr:title'];
        data.root = data.root[resource];
      }

      // Forcing setting default dimensions for Slides to ensure Author displays correctly if no dimensions on image
      if (window.location.href.indexOf('/slides/') > 1) {
        data.defaultImageWidth = '1920';
        data.defaultImageLength = '820';
      }

      const mergedData = { ...this.props, ...data };
      this.setState({ data: mergedData });
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  render() {
    
    return (
        (this.getComponentName() === 'Video') ?
            <div style={{display: 'flex'}}>
              {this.renderComponents(this.getComponentName())}
            </div> :
            <React.Fragment>
              {this.renderComponents(this.getComponentName())}
            </React.Fragment>
    );
  }
}

export default AuthorLoader;
